import { createInMemoryAtom } from '@exodus/atoms';
export const ErrorCode = {
    StateUnavailable: 'StateUnavailable',
    StateMaybeUnavailable: 'StateMaybeUnavailable',
    RegionUnavailable: 'RegionUnavailable',
    CountryUnavailable: 'CountryUnavailable',
    TemporarilyUnavailable: 'TemporarilyUnavailable',
};
Object.setPrototypeOf(ErrorCode, null);
const createExchangeAvailabilityAtom = () => createInMemoryAtom({ defaultValue: null });
export default createExchangeAvailabilityAtom;
